import Swiper from "swiper"
import { Pagination, Autoplay, Navigation } from "swiper/modules"

jQuery(window).on('elementor/frontend/init', (e) => {
  elementorFrontend.hooks.addAction(
    'frontend/element_ready/onereach-info-carousel.default',
    ($element) => {
      const infoCarouselSlider = $element.find('.onereach-info-carousel__swiper').get(0);

      const infoCarouselSwiper = new Swiper(infoCarouselSlider, {
        modules: [Pagination, Autoplay, Navigation],
        slidesPerView: 1,
        speed: 400,
        effect: "fade",
        crossFade: true,
        pagination: {
          el: ".swiper-pagination",
          type: "custom",
          renderCustom: function (swiper, current, total) {
            return current + ' - ' + total;
          }
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        autoplay: {
          delay: 12000,
          disableOnInteraction: false,
        },
        on: {
          init: function () {
            const slider = this;
            slider.autoplay.stop();

            const observer = new IntersectionObserver((entries) => {
              for (let i = 0; i < entries.length; i++) {
                const entry = entries[i];
                if (entry.isIntersecting) {
                  slider.autoplay.start();

                  // Disable observing
                  observer.unobserve(entry.target);
                  break;
                }
              }
            });
            observer.observe(slider.el);
          },
        }
      })
    }
  )
})